import React, { FC, useState, useCallback } from 'react';
import classNames from 'classnames';
import { ASSETS_PATH } from '@app/react/const/variables';

interface DimButtonProps {
    className?: string;
    disabled: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const Button3D: FC<DimButtonProps> = ({
    className,
    disabled,
    onClick,
}) => {
    const e = '3d-enable.svg';
    const d = '3d-disable.svg';
    const file = disabled ? d : e;

    return (
        <button
            type="button"
            className={classNames('btn-3d', className)}
            onClick={onClick}
        >
            <img
                src={`${ASSETS_PATH}/img/common/${file}`}
                role="presentation"
                alt=""
            />
        </button>
    );
};

const Button2D: FC<DimButtonProps> = ({
    className,
    disabled,
    onClick,
}) => {
    const e = '2d-enable.svg';
    const d = '2d-disable.svg';
    const file = disabled ? d : e;

    return (
        <button
            type="button"
            className={classNames('btn-2d', className)}
            onClick={onClick}
        >
            <img
                src={`${ASSETS_PATH}/img/common/${file}`}
                role="presentation"
                alt=""
            />
        </button>
    );
};

export interface DimensionToggleButtonProps {
    defaultValue?: boolean; // the default value represents the state of the 3d button
    onClick3d: React.MouseEventHandler<HTMLButtonElement>;
    onClick2d: React.MouseEventHandler<HTMLButtonElement>;
}

export const DimensionToggleButton: FC<DimensionToggleButtonProps> = ({
    defaultValue = true,
    onClick3d,
    onClick2d,
}) => {
    const [enable3d, setEnable3d] = useState<boolean>(defaultValue);

    const on3d: React.MouseEventHandler<HTMLButtonElement> = useCallback(
        (event) => {
            setEnable3d(true);
            onClick3d(event);
        },
        [onClick3d, setEnable3d],
    );

    const on2d: React.MouseEventHandler<HTMLButtonElement> = useCallback(
        (event) => {
            setEnable3d(false);
            onClick2d(event);
        },
        [onClick2d, setEnable3d],
    );

    return (
        <div className="dimension-toggle-button">
            <Button3D disabled={!enable3d} onClick={on3d} />
            <Button2D disabled={enable3d} onClick={on2d} />
        </div>
    );
};
